import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Text, AnimatedText } from './styles';

const Message = ({ children, isError, timing, fontStyle, className, tField, onComplete }) => {
  const { t } = useTranslation(tField);
  const Component = useMemo(() => (timing ? AnimatedText : Text), [timing]);
  const onAnimationComplete = useCallback(
    ({ display, height, opacity }) => {
      if (typeof onComplete === 'function' && display === 'none' && height === 0 && opacity === 0) onComplete();
    },
    [onComplete]
  );
  const textProps = useMemo(
    () =>
      timing
        ? { $isError: isError, $timing: timing, fontStyle, className, onAnimationComplete }
        : { $isError: isError, fontStyle, className },
    [className, fontStyle, isError, onAnimationComplete, timing]
  );

  if (!children) return null;

  return <Component {...textProps}>{tField ? t(children) : children}</Component>;
};

Message.defaultProps = {
  children: null,
  isError: false,
  timing: 0,
  fontStyle: 'small',
  className: '',
  tField: null,
  onComplete: null,
};

Message.propTypes = {
  children: PropTypes.node,
  isError: PropTypes.bool,
  timing: PropTypes.number,
  fontStyle: PropTypes.string,
  className: PropTypes.string,
  tField: PropTypes.string,
  onComplete: PropTypes.func,
};

export const Success = (props) => <Message {...props} />;
export const Error = (props) => <Message {...props} isError />;
